import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction } from './interface/apiInterface';
import { IInitialState, ITransferData } from './interface/reduxInterface';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  transfersIsLoaded: false,
  partnersIsLoaded: false,
  transferList: [],
  partnersList: [],
};

export const getListTransfers = createAction<any>(
  '@transfersApp/GET_LIST_OF_TRANSFERS'
);
export const getListTransfersError = createAction(
  '@transfersApp/GET_LIST_OF_TRANSFERS_ERROR'
);
export const getListOfPartners = createAction<any>(
  '@transfersApp/GET_LIST_OF_PARTNERS'
);

export const setFinalDateFilterOptions = createAction<any>(
  '@transfersApp/filter/SET_FINAL_DATE_FILTER_OPTION'
);

export const loadingTransferList = createAction(
  '@transfersApp/LOADING_RESPONSE'
);

export const eraserList = createAction('@transfersApp/ERASER_transfers_LIST');

export const logoutTransferApp = createAction(
  '@transfersApp/LOGOUT_transfers_APP'
);

function checkArray(props: any) {
  if (props === undefined) {
    return [];
  }
  return props;
}

const transfersAppReducer = createReducer(INITIAL_STATE, {
  [getListTransfers.type]: (state, action: IAction) => ({
    ...state,
    transferList: checkArray(action.payload).map((transfer: ITransferData) => {
      const data: ITransferData = {
        id: transfer.id,
        cod_msg: transfer.cod_msg,
        numCtrlIF: transfer.numCtrlIF,
        NumCtrlSTR: transfer.NumCtrlSTR,
        id_ispb_origem: transfer.id_ispb_origem,
        id_isbp_destino: transfer.id_isbp_destino,
        num_cab_seq: transfer.num_cab_seq,
        id_usuario: transfer.id_usuario,
        ISPBIFDebtd: transfer.ISPBIFDebtd,
        id_cliente_debtd: transfer.id_cliente_debtd,
        agencia_usuario: transfer.agencia_usuario,
        nome_cliente_debito: transfer.nome_cliente_debito,
        cnpj_cpf_debito: transfer.cnpj_cpf_debito,
        agDebtd: transfer.agDebtd,
        tpCtDebitada: transfer.tpCtDebitada,
        ctDebtd: transfer.ctDebtd,
        TpPessoaDebtd: transfer.TpPessoaDebtd,
        ISPBIFCredtd: transfer.ISPBIFCredtd,
        cnpj_cpf_clienteCredtada: transfer.cnpj_cpf_clienteCredtada,
        nome_clienteCredtada: transfer.nome_clienteCredtada,
        agCredtda: transfer.agCredtda,
        tpCtCredtda: transfer.tpCtCredtda,
        ctCredtda: transfer.ctCredtda,
        tpPessoaCredtda: transfer.tpPessoaCredtda,
        valor_lancamento: transfer.valor_lancamento,
        finalidade: transfer.finalidade,
        hist: transfer.hist,
        dtAgendamento: transfer.dtAgendamento,
        hrAgendamento: transfer.hrAgendamento,
        dt_movto: transfer.dt_movto,
        return: transfer.return,
        numCabSeq: transfer.numCabSeq,
        TpRetorno: transfer.TpRetorno,
        ConteudoXML: transfer.ConteudoXML,
        DtHrRegistro: transfer.DtHrRegistro,
        protocolo_remessas: transfer.protocolo_remessas,
        identificador: transfer.identificador,
        consent_id: transfer.consent_id,
        cnpj_initiator: transfer.cnpj_initiator,
        ibge_town_code: transfer.ibge_town_code,
        transaction_identification: transfer.transaction_identification,
        proxy: transfer.proxy,
        tp_iniciacao: transfer.tp_iniciacao,
        fila: transfer.fila,
        created_at: transfer.created_at,
        updated_at: transfer.updated_at,
        nome_razaoSocial: transfer.nome_razaoSocial,
        cpf_cnpj: transfer.cpf_cnpj,
        email: transfer.email,
        razao_social: transfer.razao_social,
        documentos: transfer.documentos,
        data_nascimento: transfer.data_nascimento,
        celular: transfer.celular,
      };
      return data;
    }),
    transfersIsLoaded: true,
    isActive: true,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
  }),
  [getListOfPartners.type]: (state, action) => ({
    ...state,
    partnersList: action.payload,
    partnersIsLoaded: true,
  }),
  [loadingTransferList.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [getListTransfersError.type]: (state) => ({
    ...state,
    isLoading: false,
    gotSuccess: false,
    gotError: false,
    transfersIsLoaded: false,
    partnersIsLoaded: false,
    transfersList: [],
  }),
  [logoutTransferApp.type]: (state) => ({
    ...state,
    isLoading: false,
    gotSuccess: false,
    gotError: false,
    transfersIsLoaded: false,
    partnersIsLoaded: false,
    transfersList: [],
  }),
});

export default transfersAppReducer;
